<script lang="ts">
	import { DefaultTextInput } from "../TextInput";

	export let length = Infinity;
	export let value = "";
	export let password = false;
	export let clearButtonCallback = () => {};

	export let errorMessage = "";
	export let error = false;
	export let focus = false;
	export let labelFor = "";
	export let inputName: string | null = null;

	export let outerClassname = "";
	export let labelClassname = "";
	export let spanClassname = "";
	export let placeholder = "";

</script>

<div class={'outer ' + outerClassname}>
	{#if inputName !== null}
		<label
			class:error
			class:focus={!error && focus}
			class={labelClassname}
			for={labelFor}>{inputName}</label>
	{/if}
	<DefaultTextInput
		length={length}
		id={labelFor}
		placeholder={placeholder}
		clearButtonDisplay={value.length > 0}
		clearCallback={clearButtonCallback}
		bind:value
		password={password}
		error={errorMessage !== ''}
		on:input
		on:focus={() => (focus = true)}
		on:blur={() => (focus = false)} />
	<slot />
	{#if errorMessage !== '' && error}
		<span class:error class={spanClassname}>{errorMessage}</span>
	{/if}
</div>

<style>
	div {
		display: flex;
		flex-direction: column;
		gap: 10px;
	}
	label {
		font-size: 1.125rem;
		transition: all 0.15s;
		color: #e6e7ed;
	}
	span {
		display: block;
		padding-left: 10px;
	}

	.focus {
		color: var(--signature-blue);
		font-weight: 500;
	}

	.error {
		color: var(--error-color-1);
	}

</style>
